<template>
  <ul class="accordion mx-auto">
    <slot></slot>
  </ul>
</template>

<script>
  import { provide, reactive } from "@vue/composition-api";
  export default {
    name: "AccordionWrapper",
    setup() {
      const accordion = reactive({
        count: 0,
        active: null,
      });
      provide("accordion", accordion);
    },
  };
</script>
<style scoped lang="scss">
  ul {
    list-style-type: none;
  }
</style>
